import React from 'react';

export default function CollectibleSection({ t }) {
  return (
    <section
      id="collectible"
      data-testid="collectible-section"
      className="relative overflow-hidden py-20 md:py-28"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative mx-auto">
          <div className="relative aspect-[1536/1024] w-full overflow-hidden rounded-2xl border border-primary/20">
            <img
              src="/assets/collectible-infographic.png"
              alt={t.collectible.title}
              data-testid="collectible-infographic"
              className="block h-full w-full select-none object-cover"
              draggable="false"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
